(ns com.theplantscape.plant-web.pages.logout-page
  (:require [com.theplantscape.web-ui.tailwind.images :refer [picture]]
            [reitit.frontend.easy :as rfe]))

(defn ui-page-unauthorized []
  [:div.tps-secondary.rounded-3xl.background-blue-200
   [:div.flex
    [:div.min-h-80 {:class "w-1/3"} 
     [picture {:image "https://img.theplantscape.com/api/image/do/401-logout-01.jpg?p=h-192"}]]
    [:div.ml-4 {:class "w-2/3"}
     [:h1.text-3xl "You are not currently logged in"]
     [:p.mt-4 "Your access may have expired please login again to access this page "
      [:a.link.ui-link {:href (rfe/href :login)} "login"]" or return to the "
      [:a.ui-link {:href (rfe/href :homepage)} "homepage."]]]]])

(defn ui-page-logout []
  [:div.tps-secondary.rounded-3xl.background-blue-200
   [:div.flex
    [:div.min-h-80 {:class "w-1/3"} 
     [picture {:image "https://img.theplantscape.com/api/image/do/404-image-01.jpg?p=h-192"}]]
    [:div.ml-4 {:class "w-2/3"}
     [:h1.text-3xl "You have been logged out"]
     [:p.mt-4 "Log back in to "
      [:a.link {:href (rfe/href :login)} "login"]" or return to the "

      [:a.link {:href (rfe/href :homepage)} "homepage."]]]]])
